import { Paper, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import { useListCustomers } from './customers-list.hook';
import { DestroyCustomersUseCase } from '../../../Usecase/Customers/destroy-customers-usecase';
import { Loader } from '../../../Components/Loader';
import { Can } from '../../../Components/Can';
import { maskPhone } from '../../../utils/maskPhone';

interface ICustomersList {
  listCustomersUseCase: ListCustomersUseCase
  destroyCustomersUseCase: DestroyCustomersUseCase
}

const CustomersList : FC<ICustomersList> = ({ listCustomersUseCase, destroyCustomersUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { loadCustomers, list, setCustomerToDestroy, boxToDestroy, handleDestroyCustomer,totalRegisters, loading } = useListCustomers({
      listCustomersUseCase,
      destroyCustomersUseCase,
      
      
    })

    useEffect(() => {
      loadCustomers({ page: 1})
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
          {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
          },
          {
            field: 'phone',
            headerName: 'Telefone',
            flex: 1
           
          },
          {
            field: 'email',
            headerName: 'E-mail',
            flex: 1,
           
          },{
            field: 'document',
            headerName: 'Documento',
            flex: 1,
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            flex: 1,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setCustomerToDestroy} editLink={`/customers-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:customers:manage']}>
        <BaseScreen>
        {loading && <Loader />}
        <ConfirmDialog title='Remover Cliente' onCancel={() => setCustomerToDestroy('')} description='Você tem certeza?' open={!!boxToDestroy} onConfirm={handleDestroyCustomer}  /> 
            <Paper >
                <BaseContentPage 
                  search
                  searchFunction={loadCustomers}
                  placeholderSearch='Pesquise pelo nome do cliente'
                    title='Clientes'
                    breadcrumb={[{ title: 'Clientes', link: "/customers-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/customers-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} totalCount={totalRegisters} columns={columns} onPageChange={loadCustomers} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { CustomersList };
